import React, { useEffect, useState } from "react";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import { doctorProfileFiles } from "../../Util/API Calls/APIList";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
const StaffContext = React.createContext();

export const StaffContextProvider = ({ children }) => {
  const [doctor_list, setDoctorList] = useState([]);
  const [selected_doctor, setSelectedDoctor] = useState([]);

  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  useEffect(() => {
    afterLoginApiAxios({
      method: "post",
      url: "/staff/get-complete-staff-info",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        "authorizer-principal-id": {
          user_type: 4,
          staff_id: staffId,
        },
        staff_id: staffId,
        search: "False",
        dr_name: "",
        dr_phone_no: "",
      },
    })
      .then((response) => {
        if (
          response?.data?.all_related_doctors &&
          response.data.all_related_doctors.length > 0
        ) {
          response.data.all_related_doctors.map(
            (data, indx) => (
              (response.data.all_related_doctors[indx].id = data.doctor_id),
              (response.data.all_related_doctors[indx].selected_doctor = false),
              (response.data.all_related_doctors[indx].label = data.dr_name),
              (response.data.all_related_doctors[indx].value =
                data.dr_first_name), //data.dr_name
              (response.data.all_related_doctors[indx].name = data.dr_name),
              (response.data.all_related_doctors[indx].initials =
                data.dr_name.charAt(0))
              // (response.data.all_related_doctors[indx].profile_picture_url =
              //   doctorProfileFiles + data.profile_picture_url)
              // (response.data.all_related_doctors[indx].label =
              //   data.dr_first_name + " " + data.dr_last_name),
              // (response.data.all_related_doctors[indx].value =
              //   data.dr_first_name + " " + data.dr_last_name),
              // (response.data.all_related_doctors[indx].name =
              //   data.dr_first_name + " " + data.dr_last_name),
              // (response.data.all_related_doctors[indx].initials =
              //   data.dr_first_name.charAt(0))
            )
          );

          setDoctorList(response.data.all_related_doctors);
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  }, []);

  useEffect(() => {
    if (localStorage.getItem("selectedDoctor")) {
      let doctorSelected = JSON.parse(localStorage.getItem("selectedDoctor"));
      doctorSelected.map((data) => {
        data.selected = true;
      });
      setSelectedDoctor(doctorSelected);
      doctor_list.map((odata, indx) => {
        doctorSelected.map((idata) => {
          if (odata.id === idata.id) {
            doctor_list[indx].selected = true;
          }
        });
      });
    } else {
      doctor_list.map((data) => {
        data.selected = true;
      });
      setSelectedDoctor(doctor_list);
    }
  }, [doctor_list]);

  return (
    <StaffContext.Provider
      value={{
        doctor_list,
        setDoctorList,
        selected_doctor,
        setSelectedDoctor,
      }}
    >
      {children}
    </StaffContext.Provider>
  );
};

export default StaffContext;
